module.exports = __webpack_public_path__ + "static/media/pins.a66c7ea0.png";